import { Component, type ReactNode } from 'react';

/**
 * Catches a failed lazy load (no connection, or files of an older version gone after an
 * update) so one missing piece — a map, the calendar grid — does not take down the screen.
 */
export class LoadBoundary extends Component<{ fallback: ReactNode; children: ReactNode }, { failed: boolean }> {
  override state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  override render() {
    return this.state.failed ? this.props.fallback : this.props.children;
  }
}
